import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	operatorEquals: {
		id: 'jql-builder-basic.utils.operators.operator-equals',
		defaultMessage: '{fieldDisplayName} {operator} (equals)',
		description: '"Somefield = (equals)" operator for the JQL builder',
	},
	operatorNotEquals: {
		id: 'jql-builder-basic.utils.operators.operator-not-equals',
		defaultMessage: '{fieldDisplayName} {operator} (not equals)',
		description: '"Somefield != (not equals)" operator for the JQL builder',
	},
	operatorWas: {
		id: 'jql-builder-basic.utils.operators.operator-was',
		defaultMessage: '{fieldDisplayName} {operator}',
		description:
			'"Somefield was" operator for the JQL builder, operator translation should be on the side between parentesis (example: "{fieldDisplayName} {operator} ({translationOfWas})")',
	},
	operatorWasNot: {
		id: 'jql-builder-basic.utils.operators.operator-was-not',
		defaultMessage: '{fieldDisplayName} {operator}',
		description:
			'"Somefield was not" operator for the JQL builder, operator translation should be on the side between parentesis (example: "{fieldDisplayName} {operator} ({translationOfWasNot})")',
	},
	operatorChanged: {
		id: 'jql-builder-basic.utils.operators.operator-changed',
		defaultMessage: '{fieldDisplayName} {operator}',
		description:
			'"Somefield changed" operator for the JQL builder, operator translation should be on the side between parentesis (example: "{fieldDisplayName} {operator} ({translationOfChanged})")',
	},
	operatorLike: {
		id: 'jql-builder-basic.utils.operators.operator-like',
		defaultMessage: '{fieldDisplayName} {operator} (like)',
		description: '"Somefield ~ (like)" operator for the JQL builder',
	},
	operatorNotLike: {
		id: 'jql-builder-basic.utils.operators.operator-not-like',
		defaultMessage: '{fieldDisplayName} {operator} (not like)',
		description: '"Somefield !~ (not like)" operator for the JQL builder',
	},
	operatorGt: {
		id: 'jql-builder-basic.utils.operators.operator-gt',
		defaultMessage: '{fieldDisplayName} {operator} (greater than)',
		description: '"Somefield > (greater than)" operator for the JQL builder',
	},
	operatorGtEquals: {
		id: 'jql-builder-basic.utils.operators.operator-gt-equals',
		defaultMessage: '{fieldDisplayName} {operator} (greater than or equals)',
		description: '"Somefield >= (greater than or equals)" operator for the JQL builder',
	},
	operatorLt: {
		id: 'jql-builder-basic.utils.operators.operator-lt',
		defaultMessage: '{fieldDisplayName} {operator} (less than)',
		description: '"Somefield < (less than)" operator for the JQL builder',
	},
	operatorLtEquals: {
		id: 'jql-builder-basic.utils.operators.operator-lt-equals',
		defaultMessage: '{fieldDisplayName} {operator} (less than or equals)',
		description: '"Somefield < (less than or equals)" operator for the JQL builder',
	},
	operatorEqualsShort: {
		id: 'jql-builder-basic.utils.operators.operator-equals-short',
		defaultMessage: '{operator} (equals)',
		description: '"= (equals)" operator for the JQL builder',
	},
	operatorNotEqualsShort: {
		id: 'jql-builder-basic.utils.operators.operator-not-equals-short',
		defaultMessage: '{operator} (not equals)',
		description: '"Somefield != (not equals)" operator for the JQL builder',
	},
	operatorWasShort: {
		id: 'jql-builder-basic.utils.operators.operator-was-short',
		defaultMessage: '{operator}',
		description:
			'"was" operator for the JQL builder, operator translation should be on the side between parentesis (example: "{operator} ({translationOfWas})")',
	},
	operatorWasNotShort: {
		id: 'jql-builder-basic.utils.operators.operator-was-not-short',
		defaultMessage: '{operator}',
		description:
			'"was not" operator for the JQL builder, operator translation should be on the side between parentesis (example: "{operator} ({translationOfWasNot})")',
	},
	operatorChangedShort: {
		id: 'jql-builder-basic.utils.operators.operator-changed-short',
		defaultMessage: '{operator}',
		description:
			'"changed" operator for the JQL builder, operator translation should be on the side between parentesis (example: "{operator} ({translationOfChanged})")',
	},
	operatorLikeShort: {
		id: 'jql-builder-basic.utils.operators.operator-like-short',
		defaultMessage: '{operator} (like)',
		description: '"~ (like)" operator for the JQL builder',
	},
	operatorNotLikeShort: {
		id: 'jql-builder-basic.utils.operators.operator-not-like-short',
		defaultMessage: '{operator} (not like)',
		description: '"!~ (not like)" operator for the JQL builder',
	},
	operatorGtShort: {
		id: 'jql-builder-basic.utils.operators.operator-gt-short',
		defaultMessage: '{operator} (greater than)',
		description: '"> (greater than)" operator for the JQL builder',
	},
	operatorGtEqualsShort: {
		id: 'jql-builder-basic.utils.operators.operator-gt-equals-short',
		defaultMessage: '{operator} (greater than or equals)',
		description: '">= (greater than or equals)" operator for the JQL builder',
	},
	operatorLtShort: {
		id: 'jql-builder-basic.utils.operators.operator-lt-short',
		defaultMessage: '{operator} (less than)',
		description: '"< (less than)" operator for the JQL builder',
	},
	operatorLtEqualsShort: {
		id: 'jql-builder-basic.utils.operators.operator-lt-equals-short',
		defaultMessage: '{operator} (less than or equals)',
		description: '"< (less than or equals)" operator for the JQL builder',
	},
	operatorEqualsAriaLabel: {
		id: 'jql-builder-basic.utils.operators.operator-equals-aria-label',
		defaultMessage: '{fieldDisplayName} equals',
		description:
			'Aria label of "=" operator, aria label are used by screen readers to describe the element',
	},
	operatorNotEqualsAriaLabel: {
		id: 'jql-builder-basic.utils.operators.operator-not-equals-aria-label',
		defaultMessage: '{fieldDisplayName} not equals',
		description:
			'Aria label of "!=" operator, aria label are used by screen readers to describe the element',
	},
	operatorWasAriaLabel: {
		id: 'jql-builder-basic.utils.operators.operator-was-aria-label',
		defaultMessage: '{fieldDisplayName} was',
		description:
			'Aria label of "was" operator, aria label are used by screen readers to describe the element',
	},
	operatorWasNotAriaLabel: {
		id: 'jql-builder-basic.utils.operators.operator-was-not-aria-label',
		defaultMessage: '{fieldDisplayName} was not',
		description:
			'Aria label of "was not" operator, aria label are used by screen readers to describe the element',
	},
	operatorChangedAriaLabel: {
		id: 'jql-builder-basic.utils.operators.operator-changed-aria-label',
		defaultMessage: '{fieldDisplayName} changed',
		description:
			'Aria label of "changed" operator, aria label are used by screen readers to describe the element',
	},
	operatorLikeAriaLabel: {
		id: 'jql-builder-basic.utils.operators.operator-like-aria-label',
		defaultMessage: '{fieldDisplayName} like',
		description:
			'Aria label of "like" operator, aria label are used by screen readers to describe the element',
	},
	operatorNotLikeAriaLabel: {
		id: 'jql-builder-basic.utils.operators.operator-not-like-aria-label',
		defaultMessage: '{fieldDisplayName} not like',
		description:
			'Aria label of "not like" operator, aria label are used by screen readers to describe the element',
	},
	operatorGtAriaLabel: {
		id: 'jql-builder-basic.utils.operators.operator-gt-aria-label',
		defaultMessage: '{fieldDisplayName} greater than',
		description:
			'Aria label of "greater than" operator, aria label are used by screen readers to describe the element',
	},
	operatorGtEqualsAriaLabel: {
		id: 'jql-builder-basic.utils.operators.operator-gt-equals-aria-label',
		defaultMessage: '{fieldDisplayName} greater than or equals',
		description:
			'Aria label of "greater than or equals" operator, aria label are used by screen readers to describe the element',
	},
	operatorLtAriaLabel: {
		id: 'jql-builder-basic.utils.operators.operator-lt-aria-label',
		defaultMessage: '{fieldDisplayName} less than',
		description:
			'Aria label of "less than" operator, aria label are used by screen readers to describe the element',
	},
	operatorLtEqualsAriaLabel: {
		id: 'jql-builder-basic.utils.operators.operator-lt-equals-aria-label',
		defaultMessage: '{fieldDisplayName} less than or equals',
		description:
			'Aria label of "less than or equals" operator, aria label are used by screen readers to describe the element',
	},
});

export default messages;
